// extracted by mini-css-extract-plugin
module.exports = {"section":"P_section__E_A4P"};